import { useWallet } from '@solana/wallet-adapter-react'
import { PublicKey } from '@solana/web3.js'
import { useConnection } from '@solana/wallet-adapter-react'
import { useEffect, useState } from 'react'
import { Buffer } from 'buffer'
import { VESTING_PROGRAM_ID } from 'utils/envs'

const PROGRAM_ID = new PublicKey(VESTING_PROGRAM_ID)

export function useAdmin() {
  const { publicKey } = useWallet()
  const { connection } = useConnection()
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function checkAdmin() {
      if (!publicKey) {
        setIsAdmin(false)
        setLoading(false)
        return
      }

      try {
        const [configPda] = PublicKey.findProgramAddressSync(
          [Buffer.from('config')],
          PROGRAM_ID
        )

        const accountInfo = await connection.getAccountInfo(configPda)
        if (!accountInfo) {
          setIsAdmin(false)
          setLoading(false)
          return
        }

        // The admin pubkey is stored at the start of the account data
        const adminPubkey = new PublicKey(accountInfo.data.slice(8, 40))
        setIsAdmin(adminPubkey.equals(publicKey))
      } catch (error) {
        console.error('Error checking admin status:', error)
        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }

    checkAdmin()
  }, [publicKey, connection])

  return { isAdmin, loading }
} 